// eslint-disable-next-line jsdoc/require-jsdoc
export async function appendFileList(fileCollection, fileList) {
    await Promise.all(toSourceAppend(fileCollection, fileList));
}
function* toSourceAppend(fileCollection, fileList) {
    for (const file of fileList) {
        const source = {
            uuid: crypto.randomUUID(),
            name: file.name,
            size: file.size,
            baseURL: 'ium:/',
            // @ts-expect-error We allow file.path as alternative to webkitRelativePath
            relativePath: file.webkitRelativePath || file.path || file.name,
            lastModified: file.lastModified,
            text: () => file.text(),
            arrayBuffer: () => file.arrayBuffer(),
            stream: () => file.stream(),
        };
        yield fileCollection.appendExtendedSource(source);
    }
}
//# sourceMappingURL=appendFileList.js.map